import * as React from 'react'
import { MoonLoader } from 'react-spinners'
import { IProviderProductObject } from '../../types/index'
import ButtonFilledGreen from '../ui/ButtonFilledGreen'
import Modal from '../ui/Modal'
import UIMessages from 'src/utils/ui-messages'

interface IProviderProductActivateModalProps {
  product?: IProviderProductObject
  activating: boolean
  error: string
  onCancelClick: () => void
  onActivateClick: (productId: string) => void
}

class ProviderProductActivateModal extends React.Component<IProviderProductActivateModalProps> {
  constructor(props: IProviderProductActivateModalProps) {
    super(props)
  }

  public render() {
    const { product, activating, error, onCancelClick, onActivateClick } = this.props

    const containerStyle = {
      width: 415,
      height: 200
    }

    return (
      <Modal>
        <div className='fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center'>
          <div className='med-modal'>
            <span className='ModalAddTitle font-small weight-300 font-grey2 uppercase'>Activate Product</span>
            <div className='mt1 border-top pt2'>
              <div className='font-grey3 h5'>Do you want to activate this product?</div>
              <li className='h5 font-grey3 mx-auto mt1 bold'>{product && product.name}</li>
            </div>
            {error && <div className='Error h5 font-orange mx-auto'>{error}</div>}
            <div className='mx-auto'>
              <MoonLoader sizeUnit={'px'} size={25} color={'#405264'} loading={activating} />
            </div>
            <div className='flex items-center justify-end mt3'>
              <button type='button' onClick={onCancelClick} className='CancelButton custom-btn mbsc-clear-btn'>
                {UIMessages.common.cancel}
              </button>
              <button
                type='button'
                onClick={this.handleActivateClick}
                className={'SubmitButton custom-btn mbsc-green-btn ml1'}
              >
                Activate
              </button>
            </div>
          </div>
        </div>
      </Modal>
    )
  }

  private handleActivateClick = () => {
    if (this.props.product && this.props.product.id) {
      this.props.onActivateClick(this.props.product.id)
    }
  }
}

export default ProviderProductActivateModal



// WEBPACK FOOTER //
// ./src/components/products/ProviderProductActivateModal.tsx